import { useState, useEffect } from 'react';

import {db} from '../database';

const useSitePins = (filter?:string, selectedSite?:any) => {
const [siteData, setSiteData] = useState<any>();
const [refreshCount, setRefreshCount] = useState(0);


  useEffect(() => {
    const sub = () => {
        setRefreshCount(refreshCount + 1);
    }
    db.on("changes", sub);
    //@ts-ignore
    return () => db.on('changes').unsubscribe (sub);
  }, [refreshCount]);


  useEffect(() => {
    const getAllSites = async () => {
        let sites;
        if(!filter || filter === 'all'){
          sites = await db.userSites.toArray();
        }else{
          const result = await db.userSites
          .where('status')
          .equals(filter)
          sites = await result.toArray();
        }
        const features = sites.reduce((acc: any, site) => {
            if(site.longitude && site.latitude && (site.userSiteId !== selectedSite)){
                acc.push({
                  type: "Feature",
                  properties: {
                      id: site.userSiteId,
                      icon: "unselected"
                  },
                  geometry: {
                      type: "Point",
                      coordinates: [ site.longitude, site.latitude ]
                  }
                }); 
            } else if (site.userSiteId === selectedSite) {
              acc.push({
                type: "Feature",
                properties: {
                    id: site.userSiteId,
                    icon: "selected"
                },
                geometry: {
                    type: "Point",
                    coordinates: [ site.longitude, site.latitude ]
                }
              });
            } 
            return acc;
        }, []);
        const featureCollection = {
            type: "FeatureCollection",
            features: features
        }
        setSiteData(featureCollection);
    }
    getAllSites();

  }, [filter, selectedSite, refreshCount]);
  return siteData;
}


  export default useSitePins;
